const cottagePathByLang = {
  sv: 'stuga',
  en: 'holiday-home',
};

export const publicCottageUrl = (cottageId, locale = 'sv') => {
  const lang = typeof locale === 'string' && locale ? locale.split('-')[0].toLowerCase() : 'sv';
  const path = cottagePathByLang[lang] || cottagePathByLang.sv;
  return `/${lang}/${path}/${cottageId}`;
};
